import { render, staticRenderFns } from "./SelectNationalDegree.vue?vue&type=template&id=73a1eea6&scoped=true&"
import script from "./SelectNationalDegree.vue?vue&type=script&lang=ts&"
export * from "./SelectNationalDegree.vue?vue&type=script&lang=ts&"
import style0 from "./SelectNationalDegree.vue?vue&type=style&index=0&id=73a1eea6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1eea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCol,VImg,VRow,VTextarea})
